var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleSheets = function SvgGoogleSheets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.281 9.727H7.625v6.136h8.75V9.727h-1.094Zm0 5H8.72v-3.864h6.562v3.864Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.688 22H6.313C5.587 22 5 21.39 5 20.636V3.364C5 2.61 5.587 2 6.313 2h7.875L19 7v13.636C19 21.39 18.413 22 17.687 22Z",
    fill: "#00AC47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.188 2 19 7h-4.813V2Z",
    fill: "#00832D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.281 9.727H7.625v6.591h8.75v-6.59h-1.094ZM8.72 10.863h2.734v1.592H8.72v-1.592Zm0 4.319V13.59h2.734v1.59H8.72Zm6.562 0h-2.734V13.59h2.734v1.59Zm0-2.728h-2.734v-1.59h2.734v1.59Z",
    fill: "#fff"
  })));
};
export default SvgGoogleSheets;